$(document).on("product-branding:section:product-branding", function () {
    if ($("#page-product-branding").length > 0) {
        initProductBranding();
    }
});

// page commercial video
function initProductBranding() {
    /***************************

        portfolio slider

        ***************************/
    const main = new Swiper('.swiper-portfolio', {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 800,
        parallax: true,
        mousewheel: {
            enable: true
        },
        navigation: {
            nextEl: '.mil-portfolio-next',
            prevEl: '.mil-portfolio-prev',
        },
        pagination: {
            el: '.swiper-portfolio-pagination',
            type: 'fraction',
        },
    });

    const descr = new Swiper('.swiper-descr', {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 800,
        parallax: true,
        // vertical
        direction: 'vertical',
        autoHeight: true,
        height: 180,
        // touch disable
        allowTouchMove: false,
    });

    main.on("slideChange", function () {
        descr.slideTo(main.activeIndex);
    });

    let tl = gsap.timeline();

    tl.fromTo(".swiper-portfolio", {
        opacity: 0,
    }, {
        opacity: 1,
        duration: 1,
        ease: "ease",
    });

    tl.addLabel("section-content", "<");

    tl.fromTo(".swiper-portfolio", {
        transform: "translateX(100%)",
    }, {
        transform: "translateX(0)",
        duration: 1,
        ease: "ease",
    }, "section-content");

    tl.addLabel("section-content-1", "<");

    tl.fromTo(".descr-wrapper .mil-portfolio-item", {
        opacity: 0,
        transform: "translateY(100%)",
    }, {
        opacity: 1,
        duration: 1,
        transform: "translateY(0)",
        ease: "ease",
    }, "section-content-1");

    tl.addLabel("section-content-2", "<");

    tl.fromTo(".mil-portfolio-btns-frame", {
        opacity: 0,
        transform: "translateY(100%)",
    }, {
        opacity: 1,
        duration: 1,
        transform: "translateY(0)",
        ease: "ease",
    }, "section-content-2");
}

$(document).on("product-branding-detail:section:product-branding-detail", function () {
    if ($("#page-product-branding-detail").length > 0) {
        initProductBrandingDetail();
    }
});

function initProductBrandingDetail() {
    let tl = gsap.timeline();

    tl.fromTo(".banner-wrapper", {
        opacity: 0,
    }, {
        opacity: 1,
        duration: 0.5,
        ease: "ease",
    });

    tl.addLabel("banner-wrapper", "<");

    tl.fromTo(".banner-wrapper", {
        translateY: "100%",
        "--background-opacity": 0.5,
    }, {
        translateY: "0%",
        "--background-opacity": 0.7,
        duration: 1,
        ease: "power2.out",
    }, "banner-wrapper");

    tl.addLabel("banner-logo", "+=0.5");

    tl.fromTo(".product-branding-logo", {
        opacity: 0,
    }, {
        opacity: 1,
        duration: 0.5,
        ease: "power2.out",
    }, "banner-logo");
}
